import type { ContactEntry } from '../services/profileService'

function trimStr(v: string | null | undefined): string {
  return typeof v === 'string' ? v.trim() : ''
}

/** Prefer work email, then personal email. */
export function displayEmail(c: Pick<ContactEntry, 'workEmail' | 'email'> | null | undefined): string {
  if (!c) return ''
  return trimStr(c.workEmail) || trimStr(c.email) || ''
}

/** Prefer work phone, then personal phone. */
export function displayPhone(c: Pick<ContactEntry, 'workPhone' | 'phone'> | null | undefined): string {
  if (!c) return ''
  return trimStr(c.workPhone) || trimStr(c.phone) || ''
}
